// extracted by mini-css-extract-plugin
export default {"menuItem":"styles_menuItem__fstwE","menuOverlay":"styles_menuOverlay__fXfcN"};